import React from "react";
import { useAsync } from "react-async";
import { getAllFacultyMembers } from "services";
import { FacultyCard } from "./FacultyCard";

export function FacultyList(): JSX.Element {
  const { data } = useAsync({ promiseFn: getAllFacultyMembers });

  return (
    <>
      {data &&
        data
          .filter(facultyMember => facultyMember.display === true)
          .map(facultyMember => (
            <FacultyCard key={facultyMember.id} facultyMember={facultyMember} />
          ))}
    </>
  );
}
